export const AUTHENTICATED = 'auth::authenticated';
export const AUTHENTICATING = 'auth::authenticating';
export const UNAUTHENTICATED = 'auth::unauthenticated';
export const AUTHENTICATION_ERROR = 'auth::authentication_error';


// WEBPACK FOOTER //
// ./src/action-types/auth.js